import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
	Modal, Button, FormGroup, FormControl, ControlLabel,
} from 'react-bootstrap';
import { withDebounce } from '@components';

const DebouncedFormControl = withDebounce(FormControl);

export default class DenialReasonModal extends PureComponent {
	constructor(props) {
		super(props);

		this.initialState = {
			show       : false,
			estimateId : null,
			reasonNote : '',
		};

		this.state = { ...this.initialState };
	}

	openModal = ({ show, estimateId }) => this.setState({ show, estimateId });

	resetModal = () => this.setState(this.initialState);

	updateReasonNote = ({ target : { value } }) => this.setState({ reasonNote : value });

	render() {
		const { show, reasonNote, estimateId } = this.state;
		const { updateEstimateStatus } = this.props;

		// TODO Add a loading indicator

		return (
			<Modal show={show}>
				<Modal.Header>
					<Modal.Title>Denial Reason</Modal.Title>
				</Modal.Header>
				<Modal.Body>
					<FormGroup controlId="reasonNote">
						<ControlLabel>Please specify why are you denying this estimate:</ControlLabel>
						<DebouncedFormControl
							componentClass="textarea"
							placeholder="Reason..."
							onChange={this.updateReasonNote}
							value={reasonNote}
						/>
					</FormGroup>
				</Modal.Body>
				<Modal.Footer>
					<Button
						id="deny-estimate"
						bsStyle="primary"
						onClick={updateEstimateStatus(estimateId, reasonNote)}
					>
						Deny
					</Button>
					<Button
						id="cancel-deny-estimate"
						onClick={this.resetModal}
					>
						Cancel
					</Button>
				</Modal.Footer>
			</Modal>
		);
	}
}

DenialReasonModal.propTypes = {
	updateEstimateStatus : PropTypes.func.isRequired,
};
